export const movies = [
  {
    id: 'm1',
    title: '春夜迷情',
    category: '电影',
    genres: ['爱情', '悬疑'],
    region: '韩国',
    year: 2024,
    director: '朴哲民',
    cast: ['金敏书', '李在勋', '崔秀晶'],
    synopsis: '一场春夜里偶遇的陌生人，让已婚的女主角在平静生活与危险心动之间反复挣扎。',
    plot:
      '任职于出版社的智秀，在一次加班后的春夜偶遇摄影师在勋。两人从陌生到熟悉，暧昧在雨夜与街灯之间悄然滋长。智秀的婚姻早已名存实亡，而丈夫的冷漠让她愈发难以抗拒这份突如其来的心动。当秘密一次次被掩盖，谎言与真心的界限逐渐模糊，一段足以摧毁所有人的关系就此展开。',
    rating: 8.4,
    duration: '112分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20moody%20urban%20spring%20night%20scene%2C%20two%20distant%20elegant%20figures%20standing%20apart%20under%20warm%20crimson%20neon%20lights%2C%20rain%20slicked%20street%20reflections%2C%20dramatic%20shadows%2C%20deep%20red%20and%20deep%20charcoal%20tones%2C%20film%20noir%20atmosphere%2C%20emotional%20melodrama%20mood&width=400&height=600&seq=jq-mv-01&orientation=portrait',
    coverAlt: '春夜迷情 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Atmospheric%20rainy%20city%20street%20at%20night%20with%20warm%20crimson%20neon%20reflections%20on%20wet%20asphalt%2C%20lone%20figure%20silhouette%20in%20the%20distance%2C%20cinematic%20wide%20shot%2C%20deep%20red%20and%20charcoal%20color%20grade%2C%20moody%20romantic%20drama%20tone%2C%20film%20grain&width=1600&height=900&seq=jq-hero-01&orientation=landscape',
    ],
    actors: [
      { name: '金敏书', role: '饰 智秀' },
      { name: '李在勋', role: '饰 在勋' },
      { name: '崔秀晶', role: '饰 敏京' },
    ],
  },
  {
    id: 'm2',
    title: '暗涌',
    category: '电影',
    genres: ['剧情', '伦理'],
    region: '中国大陆',
    year: 2023,
    director: '张之远',
    cast: ['周晚', '陈国立', '林小满'],
    synopsis: '看似体面的中产家庭，在一次次应酬与隐瞒中，暗涌着无法言说的背叛。',
    plot:
      '建筑设计师周晚事业有成，家庭美满，却在一次项目合作中与旧识重逢。表面的平静生活之下，是丈夫常年缺席的孤独与婆婆无声的施压。当一段越界的关系悄然发生，周晚在两个身份之间疲于奔命。真相被揭开的那天，没人能全身而退。',
    rating: 8.1,
    duration: '126分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20composed%20woman%20in%20a%20dark%20elegant%20coat%20gazing%20away%2C%20blurred%20city%20apartment%20window%20behind%20her%2C%20cold%20blue%20grey%20and%20muted%20red%20highlights%2C%20restrained%20drama%20tone%2C%20soft%20rain%20on%20glass%2C%20high%20detail%20editorial%20photography&width=400&height=600&seq=jq-mv-02&orientation=portrait',
    coverAlt: '暗涌 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Elegant%20modern%20apartment%20interior%20at%20dusk%20seen%20through%20rain%20covered%20floor%20to%20ceiling%20windows%2C%20empty%20living%20room%20with%20deep%20shadows%2C%20restrained%20melancholic%20color%20grade%20in%20charcoal%20and%20muted%20crimson%2C%20slow%20cinematic%20drama%20atmosphere&width=1600&height=900&seq=jq-hero-02&orientation=landscape',
    ],
    actors: [
      { name: '周晚', role: '饰 周晚' },
      { name: '陈国立', role: '饰 陆铭' },
      { name: '林小满', role: '饰 顾晓' },
    ],
  },
  {
    id: 'm3',
    title: '色戒边缘',
    category: '电影',
    genres: ['剧情', '爱情'],
    region: '中国香港',
    year: 2022,
    director: '陈可岚',
    cast: ['苏文豪', '何静仪', '黄志森'],
    synopsis: '霓虹黯淡的旧城中，一个男人在两个女人之间，编织着无法收场的谎言。',
    plot:
      '港岛老城区，茶餐厅老板苏文豪过着看似平淡的生活。妻子何静仪操持家务，而来自内地的新邻居阿岚却让他重新燃起久违的热情。一边是责任，一边是欲望，他开始用一个个借口填补漏洞。当两个女人在同一张餐桌前相遇，所有伪装轰然倒塌。',
    rating: 7.6,
    duration: '118分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20movie%20poster%20of%20a%20man%20in%20white%20shirt%20lit%20by%20flickering%20neon%20signs%20at%20night%2C%20narrow%20old%20alley%20behind%20him%2C%20saturated%20red%20and%20amber%20tones%20against%20dark%20shadows%2C%20gritty%20nostalgic%20film%20look%2C%20high%20detail&width=400&height=600&seq=jq-mv-03&orientation=portrait',
    coverAlt: '色戒边缘 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Old%20Hong%20Kong%20street%20at%20night%20with%20dense%20glowing%20neon%20signs%20and%20steam%20rising%20from%20street%20stalls%2C%20wet%20pavement%20reflections%2C%20warm%20red%20and%20yellow%20neon%20against%20deep%20darkness%2C%20cinematic%20moody%20atmosphere&width=1600&height=900&seq=jq-hero-03&orientation=landscape',
    ],
    actors: [
      { name: '苏文豪', role: '饰 苏文豪' },
      { name: '何静仪', role: '饰 静仪' },
      { name: '黄志森', role: '饰 阿森' },
    ],
  },
  {
    id: 'm4',
    title: '婚戒背后',
    category: '电视剧',
    genres: ['都市', '情感'],
    region: '中国大陆',
    year: 2024,
    director: '李慕白',
    cast: ['苏晴', '陆延', '江黎'],
    synopsis: '一枚婚戒，锁住三段截然不同的婚姻，也藏着三个不肯说破的秘密。',
    plot:
      '金牌律师苏晴接下一桩离婚案，却发现当事人正是自己丈夫陆延的合作伙伴。与此同时，闺蜜江黎的婚姻也亮起红灯。三个女人在事业、家庭与情感之间各自挣扎，婚戒背后是被忽视的孤独与一次次越界的诱惑。当她们选择直面真相，每个人都必须付出代价。',
    rating: 8.0,
    duration: '共36集',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20an%20elegant%20businesswoman%20holding%20a%20wedding%20ring%2C%20city%20skyline%20at%20night%20in%20the%20background%2C%20sophisticated%20charcoal%20and%20deep%20red%20palette%2C%20clean%20editorial%20fashion%20photography%2C%20subtle%20tension&width=400&height=600&seq=jq-mv-04&orientation=portrait',
    coverAlt: '婚戒背后 电视剧海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Modern%20city%20night%20skyline%20with%20glass%20office%20towers%2C%20warm%20window%20lights%20scattered%20across%20dark%20facades%2C%20deep%20red%20and%20charcoal%20color%20grade%2C%20urban%20melodrama%20cinematic%20wide%20shot&width=1600&height=900&seq=jq-hero-04&orientation=landscape',
    ],
    actors: [
      { name: '苏晴', role: '饰 苏晴' },
      { name: '陆延', role: '饰 陆延' },
      { name: '江黎', role: '饰 江黎' },
    ],
  },
  {
    id: 'm5',
    title: '双重生活',
    category: '电视剧',
    genres: ['悬疑', '剧情'],
    region: '美国',
    year: 2023,
    director: 'David Reeve',
    cast: ['Emma Hale', 'Julian Cross'],
    synopsis: '一个完美的丈夫、一个温柔的妻子，两段婚姻，一张无法见光的网。',
    plot:
      '投资顾问 Mark 在两个城市拥有两个家庭，多年来滴水不漏。直到一场意外让两条人生轨迹产生交集，他精心维系的平衡开始崩塌。妻子 Sarah 在整理丈夫遗落的物件时，发现了另一个女人的名字。一场关于身份、谎言与自我救赎的追查就此展开。',
    rating: 7.9,
    duration: '共10集',
    cover:
      'https://readdy.ai/api/search-image?query=Psychological%20thriller%20series%20poster%20of%20a%20man%20in%20a%20sharp%20suit%20split%20between%20two%20mirrored%20cityscapes%2C%20cold%20grey%20and%20dark%20red%20duotone%2C%20double%20exposure%20technique%2C%20tense%20cinematic%20prestige%20drama%20look&width=400&height=600&seq=jq-mv-05&orientation=portrait',
    coverAlt: '双重生活 剧集海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Split%20composition%20of%20two%20different%20American%20cities%20at%20night%20under%20the%20same%20stormy%20sky%2C%20cold%20grey%20and%20deep%20red%20duotone%20grade%2C%20moody%20psychological%20thriller%20cinematic%20wide%20shot&width=1600&height=900&seq=jq-hero-05&orientation=landscape',
    ],
    actors: [
      { name: 'Emma Hale', role: '饰 Sarah' },
      { name: 'Julian Cross', role: '饰 Mark' },
    ],
  },
  {
    id: 'm6',
    title: '危险关系',
    category: '电影',
    genres: ['爱情', '剧情'],
    region: '法国',
    year: 2021,
    director: 'Claire Moreau',
    cast: ['Adèle Rousseau', 'Marc Villon'],
    synopsis: '一场以征服为目的的暧昧游戏，最终让两个玩弄感情的人都深陷其中。',
    plot:
      '在巴黎上流社会的晚宴上，魅力十足的侯爵夫人与风流成性的旧情人立下赌约：谁能先让一位忠贞的年轻女子动心。两人以挑逗与算计开局，却在一次次交锋中越过自己设下的界线。游戏失控的那一刻，输赢早已不再重要，留下的只有真心与伤害。',
    rating: 7.8,
    duration: '124分钟',
    cover:
      'https://readdy.ai/api/search-image?query=French%20romantic%20drama%20poster%20of%20a%20glamorous%20woman%20in%20an%20ornate%20candlelit%20ballroom%2C%20rich%20deep%20red%20velvet%20and%20gold%20tones%20with%20deep%20shadows%2C%20elegant%20aristocratic%20period%20atmosphere%2C%20painterly%20cinematic%20lighting&width=400&height=600&seq=jq-mv-06&orientation=portrait',
    coverAlt: '危险关系 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Opulent%20candlelit%20French%20ballroom%20with%20chandeliers%20and%20deep%20red%20velvet%20drapes%2C%20blurred%20elegant%20figures%20dancing%2C%20warm%20golden%20and%20crimson%20tones%2C%20period%20drama%20cinematic%20wide%20shot&width=1600&height=900&seq=jq-hero-06&orientation=landscape',
    ],
    actors: [
      { name: 'Adèle Rousseau', role: '饰 侯爵夫人' },
      { name: 'Marc Villon', role: '饰 子爵' },
    ],
  },
  {
    id: 'm7',
    title: '午夜巴黎情事',
    category: '电影',
    genres: ['爱情', '文艺'],
    region: '法国',
    year: 2020,
    director: 'Julien Barbot',
    cast: ['Camille Auclair', 'Théo Marchand'],
    synopsis: '午夜的巴黎街头，一次错过的出租车，让两个陌生人的命运悄然交错。',
    plot:
      '独居巴黎的插画师 Marie 常在深夜散步。一个雨夜，她与刚结束失败婚姻的提琴手 Théo 在塞纳河畔偶遇。两人约定只谈今夜、不问过去，却在一次次的午夜漫步中越陷越深。当黎明来临，他们必须决定，这段始于偶然的关系是否值得被带进现实。',
    rating: 7.4,
    duration: '106分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Artistic%20Parisian%20film%20poster%20of%20two%20figures%20walking%20along%20the%20Seine%20at%20midnight%2C%20warm%20street%20lamps%20and%20soft%20rain%2C%20muted%20amber%20and%20deep%20red%20tones%20with%20deep%20shadows%2C%20dreamy%20romantic%20atmosphere%2C%20film%20grain&width=400&height=600&seq=jq-mv-07&orientation=portrait',
    coverAlt: '午夜巴黎情事 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Seine%20river%20embankment%20in%20Paris%20at%20midnight%20with%20warm%20glowing%20street%20lamps%20and%20wet%20cobblestones%2C%20lone%20figure%20in%20the%20distance%2C%20muted%20amber%20and%20deep%20charcoal%20cinematic%20color%20grade&width=1600&height=900&seq=jq-hero-07&orientation=landscape',
    ],
    actors: [
      { name: 'Camille Auclair', role: '饰 Marie' },
      { name: 'Théo Marchand', role: '饰 Théo' },
    ],
  },
  {
    id: 'm8',
    title: '红杏',
    category: '电影',
    genres: ['剧情', '伦理'],
    region: '日本',
    year: 2019,
    director: '中村浩',
    cast: ['佐藤绫', '高桥启'],
    synopsis: '被家务与沉默淹没的妻子，在庭院的一树红杏下，做出了背叛的决定。',
    plot:
      '结婚七年的 Mayumi 过着波澜不惊的家庭主妇生活，丈夫整日埋首工作，两人几乎没有交流。一次偶然，她与来修缮庭院的年轻园艺人相识。从一杯茶到一次次交谈，被压抑多年的情感在庭院里慢慢复苏。当红杏结满枝头，她必须面对内心的选择与随之而来的代价。',
    rating: 7.7,
    duration: '115分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Japanese%20drama%20film%20poster%20of%20a%20woman%20in%20a%20quiet%20traditional%20courtyard%20with%20a%20blooming%20apricot%20tree%2C%20soft%20diffused%20light%2C%20muted%20red%20and%20earthy%20charcoal%20tones%20with%20deep%20shadows%2C%20restrained%20melancholic%20cinematic%20mood&width=400&height=600&seq=jq-mv-08&orientation=portrait',
    coverAlt: '红杏 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Serene%20Japanese%20courtyard%20with%20a%20blooming%20red%20apricot%20tree%2C%20traditional%20wooden%20house%20and%20stone%20path%2C%20soft%20overcast%20light%2C%20muted%20earth%20and%20crimson%20tones%2C%20quiet%20melodrama%20cinematic%20wide%20shot&width=1600&height=900&seq=jq-hero-08&orientation=landscape',
    ],
    actors: [
      { name: '佐藤绫', role: '饰 真由美' },
      { name: '高桥启', role: '饰 启太' },
    ],
  },
  {
    id: 'm9',
    title: '出轨时代',
    category: '电视剧',
    genres: ['都市', '情感'],
    region: '韩国',
    year: 2024,
    director: '郑恩书',
    cast: ['韩智媛', '朴胜浩', '李民基'],
    synopsis: '一档探讨婚姻的电视节目，意外揭开了主持人自己婚姻里的秘密。',
    plot:
      '知名情感节目主持人智媛以犀利点评他人婚姻著称，却不知自己的丈夫正与同事暗中往来。随着节目录制的深入，嘉宾们的故事一次次映照出她生活的裂痕。当真相以最公开的方式被揭开，她在镜头前后的两副面孔再也无法维系。',
    rating: 8.2,
    duration: '共16集',
    cover:
      'https://readdy.ai/api/search-image?query=Korean%20urban%20drama%20poster%20of%20a%20stylish%20TV%20hostess%20under%20studio%20spotlights%2C%20dark%20red%20and%20charcoal%20palette%2C%20glossy%20sophisticated%20editorial%20photography%2C%20dramatic%20contrast%20lighting&width=400&height=600&seq=jq-mv-09&orientation=portrait',
    coverAlt: '出轨时代 剧集海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Empty%20modern%20TV%20studio%20with%20spotlights%20and%20a%20single%20chair%20on%20stage%2C%20deep%20red%20and%20charcoal%20color%20grade%2C%20tense%20atmospheric%20melodrama%20cinematic%20wide%20shot&width=1600&height=900&seq=jq-hero-09&orientation=landscape',
    ],
    actors: [
      { name: '韩智媛', role: '饰 智媛' },
      { name: '朴胜浩', role: '饰 胜浩' },
      { name: '李民基', role: '饰 民基' },
    ],
  },
  {
    id: 'm10',
    title: '隔壁的女人',
    category: '电影',
    genres: ['悬疑', '剧情'],
    region: '西班牙',
    year: 2022,
    director: 'Pedro Salas',
    cast: ['Lucía Vega', 'Andrés Rey'],
    synopsis: '新搬来的女邻居热情得过分，而她的丈夫，似乎早已习惯了隐瞒。',
    plot:
      '搬进老公寓楼的作家 Hugo，很快被隔壁邻居 Elena 的殷勤吸引。两人从借糖到深夜闲聊，暧昧在狭窄的走廊里蔓延。然而丈夫的缺席、深夜的争吵与一张旧照片，让 Hugo 逐渐察觉这栋楼里藏着更深的秘密。当他试图抽身，真相却比他想象的更危险。',
    rating: 7.5,
    duration: '108分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Spanish%20suspense%20thriller%20poster%20of%20two%20apartment%20doors%20facing%20each%20other%20across%20a%20narrow%20dim%20hallway%2C%20warm%20doorway%20light%20against%20deep%20dark%20shadows%2C%20deep%20red%20accents%2C%20unsettling%20cinematic%20mood&width=400&height=600&seq=jq-mv-10&orientation=portrait',
    coverAlt: '隔壁的女人 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Dim%20narrow%20apartment%20building%20hallway%20with%20a%20single%20door%20ajar%20casting%20warm%20light%2C%20deep%20shadows%20and%20muted%20crimson%20tones%2C%20tense%20suspense%20cinematic%20wide%20shot&width=1600&height=900&seq=jq-hero-10&orientation=landscape',
    ],
    actors: [
      { name: 'Lucía Vega', role: '饰 Elena' },
      { name: 'Andrés Rey', role: '饰 Hugo' },
    ],
  },
  {
    id: 'm11',
    title: '迷城',
    category: '电视剧',
    genres: ['悬疑', '情感'],
    region: '中国香港',
    year: 2023,
    director: '关志豪',
    cast: ['郑嘉铭', '周慧敏', '吴镇宇'],
    synopsis: '一桩失踪案，牵出警队、商界与三个家庭之间错综复杂的情感纠葛。',
    plot:
      '重案组警司嘉铭在调查一宗富商失踪案时，意外发现案件与自己妻子慧敏的旧友有关。随着线索层层展开，一段隐藏多年的婚外关系浮出水面。嘉铭在职责与情感之间挣扎，而这座城市本身，也像一座困住所有人的迷城。',
    rating: 7.8,
    duration: '共24集',
    cover:
      'https://readdy.ai/api/search-image?query=Suspense%20crime%20series%20poster%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20neon%20lit%20Hong%20Kong%20street%2C%20deep%20red%20and%20cold%20charcoal%20palette%2C%20cinematic%20noir%20mood%2C%20high%20detail&width=400&height=600&seq=jq-mv-11&orientation=portrait',
    coverAlt: '迷城 剧集海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Rainy%20Hong%20Kong%20cityscape%20at%20night%20seen%20from%20above%2C%20glowing%20neon%20streets%20and%20wet%20reflections%2C%20deep%20red%20and%20cold%20charcoal%20noir%20color%20grade%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=jq-hero-11&orientation=landscape',
    ],
    actors: [
      { name: '郑嘉铭', role: '饰 嘉铭' },
      { name: '周慧敏', role: '饰 慧敏' },
      { name: '吴镇宇', role: '饰 陈兆伦' },
    ],
  },
  {
    id: 'm12',
    title: '欲望都市之夏',
    category: '电影',
    genres: ['爱情', '剧情'],
    region: '美国',
    year: 2021,
    director: 'Sophie Warren',
    cast: ['Chloe Adams', 'Ryan Cole'],
    synopsis: '一个炎热的纽约夏天，四个成年人的感情像天气一样失控。',
    plot:
      '广告策划 Chloe 与丈夫的婚姻进入倦怠期，一次公司项目让她与自由摄影师 Ryan 频繁接触。都市的夏日派对上，酒精、音乐与深夜的对话让界限一再模糊。当激情退去，留下的问题比答案更多，所有人都必须为自己的选择负责。',
    rating: 7.2,
    duration: '102分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20summer%20romantic%20drama%20poster%20of%20a%20woman%20in%20a%20city%20rooftop%20party%20at%20dusk%2C%20string%20lights%20and%20deep%20red%20evening%20tones%20with%20charcoal%20shadows%2C%20sophisticated%20cinematic%20editorial%20photography&width=400&height=600&seq=jq-mv-12&orientation=portrait',
    coverAlt: '欲望都市之夏 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=New%20York%20rooftop%20party%20at%20dusk%20with%20string%20lights%20and%20city%20skyline%2C%20warm%20amber%20and%20deep%20red%20tones%20against%20dark%20blue%20hour%20sky%2C%20cinematic%20romantic%20wide%20shot&width=1600&height=900&seq=jq-hero-12&orientation=landscape',
    ],
    actors: [
      { name: 'Chloe Adams', role: '饰 Chloe' },
      { name: 'Ryan Cole', role: '饰 Ryan' },
    ],
  },
  {
    id: 'm13',
    title: '静默的背叛',
    category: '电影',
    genres: ['剧情', '悬疑'],
    region: '英国',
    year: 2023,
    director: 'Oliver Grant',
    cast: ['Eleanor West', 'James Hart'],
    synopsis: '海边的宁静小镇里，一段无人知晓的婚外关系，正被潮水慢慢揭开。',
    plot:
      '一家海边旅馆的女主人 Eleanor 与本地教师 James 维持着一段无人察觉的秘密关系。小镇的平静之下，是人言、旧怨与无法言说的孤独。当一封信被意外寄错，秘密如同涨潮般漫过他们精心修筑的堤坝。凛冽的海风里，没有人能永远沉默。',
    rating: 8.0,
    duration: '121分钟',
    cover:
      'https://readdy.ai/api/search-image?query=British%20drama%20film%20poster%20of%20a%20woman%20in%20a%20wool%20coat%20standing%20on%20a%20windy%20seaside%20cliff%2C%20grey%20stormy%20sea%2C%20muted%20red%20scarf%20accent%20against%20cold%20charcoal%20tones%2C%20restrained%20cinematic%20mood&width=400&height=600&seq=jq-mv-13&orientation=portrait',
    coverAlt: '静默的背叛 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Stormy%20grey%20British%20seaside%20cliff%20at%20dusk%20with%20crashing%20waves%2C%20lone%20figure%20silhouette%2C%20muted%20crimson%20accent%20against%20cold%20charcoal%20cinematic%20color%20grade&width=1600&height=900&seq=jq-hero-13&orientation=landscape',
    ],
    actors: [
      { name: 'Eleanor West', role: '饰 Eleanor' },
      { name: 'James Hart', role: '饰 James' },
    ],
  },
  {
    id: 'm14',
    title: '十年之痒',
    category: '电视剧',
    genres: ['家庭', '情感'],
    region: '中国大陆',
    year: 2022,
    director: '王安平',
    cast: ['何雅', '徐睿', '田甜'],
    synopsis: '结婚十年的夫妻，在柴米油盐与新鲜感之间，走到了感情的十字路口。',
    plot:
      '何雅与徐睿曾是令人羡慕的模范夫妻，十年过去，生活被孩子、房贷与琐事填满。一次同学聚会让何雅重逢初恋，而丈夫也在工作中遇到了愿意倾听他的人。两人都在克制与动摇之间反复，这个家能否熬过所谓的“十年之痒”。',
    rating: 7.6,
    duration: '共30集',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20family%20drama%20series%20poster%20of%20a%20couple%20sitting%20apart%20at%20opposite%20ends%20of%20a%20dining%20table%2C%20soft%20lamp%20light%2C%20muted%20red%20and%20warm%20charcoal%20tones%2C%20subtle%20melancholy%2C%20cinematic%20editorial%20style&width=400&height=600&seq=jq-mv-14&orientation=portrait',
    coverAlt: '十年之痒 剧集海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Quiet%20warm%20Chinese%20family%20living%20room%20in%20the%20evening%20with%20lamp%20light%20and%20an%20empty%20dining%20table%2C%20muted%20red%20and%20warm%20charcoal%20cinematic%20color%20grade&width=1600&height=900&seq=jq-hero-14&orientation=landscape',
    ],
    actors: [
      { name: '何雅', role: '饰 何雅' },
      { name: '徐睿', role: '饰 徐睿' },
      { name: '田甜', role: '饰 甜甜' },
    ],
  },
  {
    id: 'm15',
    title: '深海诱惑',
    category: '电影',
    genres: ['爱情', '惊悚'],
    region: '韩国',
    year: 2020,
    director: '姜在旭',
    cast: ['尹素妍', '金武烈'],
    synopsis: '一次海边的邂逅，让一段婚姻在深不见底的欲望里逐渐溺亡。',
    plot:
      '海洋研究员素妍与丈夫来到偏僻的海边小镇度假，结识了神秘而迷人的潜水教练金武烈。丈夫的猜忌、素妍的动摇与武烈的步步紧逼，让这个夏天变得危险。当一桩意外发生，平静的海面之下，是无法回头的深渊。',
    rating: 7.3,
    duration: '110分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Romantic%20thriller%20poster%20of%20a%20woman%20standing%20in%20shallow%20dark%20sea%20water%20at%20dusk%2C%20deep%20teal%20and%20crimson%20tones%20with%20deep%20shadows%2C%20tense%20sensual%20cinematic%20atmosphere%2C%20high%20detail&width=400&height=600&seq=jq-mv-15&orientation=portrait',
    coverAlt: '深海诱惑 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Dark%20moody%20sea%20at%20dusk%20with%20gentle%20waves%20and%20deep%20crimson%20horizon%20glow%2C%20cold%20teal%20water%20and%20deep%20charcoal%20tones%2C%20tense%20cinematic%20wide%20shot&width=1600&height=900&seq=jq-hero-15&orientation=landscape',
    ],
    actors: [
      { name: '尹素妍', role: '饰 素妍' },
      { name: '金武烈', role: '饰 武烈' },
    ],
  },
  {
    id: 'm16',
    title: '罪爱',
    category: '电影',
    genres: ['剧情', '犯罪'],
    region: '意大利',
    year: 2018,
    director: 'Luca Ferrara',
    cast: ['Giulia Conti', 'Marco Bruno'],
    synopsis: '当爱情与罪行纠缠在一起，最深的背叛往往来自最亲密的人。',
    plot:
      '律师 Giulia 为一名涉嫌杀妻的商人辩护，却在调查中与对方的生意伙伴 Marco 产生了危险的牵连。随着证据浮出水面，她发现真相远比辩护词复杂。爱情、利益与罪恶交织，每个人都在这场审判中隐瞒着自己的动机。',
    rating: 7.9,
    duration: '128分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Italian%20crime%20drama%20poster%20of%20a%20woman%20lawyer%20lit%20by%20dramatic%20window%20light%20in%20a%20dark%20courthouse%2C%20deep%20red%20and%20charcoal%20palette%2C%20tense%20cinematic%20chiaroscuro%20lighting%2C%20high%20detail&width=400&height=600&seq=jq-mv-16&orientation=portrait',
    coverAlt: '罪爱 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Dark%20empty%20Italian%20courthouse%20hall%20with%20dramatic%20shafts%20of%20light%20through%20tall%20windows%2C%20deep%20red%20and%20charcoal%20cinematic%20color%20grade%2C%20tense%20atmosphere&width=1600&height=900&seq=jq-hero-16&orientation=landscape',
    ],
    actors: [
      { name: 'Giulia Conti', role: '饰 Giulia' },
      { name: 'Marco Bruno', role: '饰 Marco' },
    ],
  },
  {
    id: 'm17',
    title: '玻璃之心',
    category: '电视剧',
    genres: ['都市', '悬疑'],
    region: '日本',
    year: 2023,
    director: '石川凉',
    cast: ['长泽美咲', '山田悠真'],
    synopsis: '表面无懈可击的完美夫妻，内心却像玻璃一样脆弱易碎。',
    plot:
      '室内设计师美咲与外科医生悠真是一对模范夫妻，社交媒体上的人生令人艳羡。然而镜头之外，两人各自守着不肯示人的秘密。一次意外的短信，让这段精心维持的关系出现裂痕。当伪装被一层层剥下，他们终于看清彼此真实的模样。',
    rating: 7.7,
    duration: '共12集',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20Japanese%20drama%20poster%20of%20an%20elegant%20couple%20standing%20separately%20behind%20frosted%20glass%2C%20cool%20charcoal%20and%20deep%20red%20accent%20tones%2C%20restrained%20cinematic%20minimalist%20style&width=400&height=600&seq=jq-mv-17&orientation=portrait',
    coverAlt: '玻璃之心 剧集海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Minimalist%20modern%20Japanese%20apartment%20at%20night%20with%20frosted%20glass%20panels%20and%20warm%20interior%20light%2C%20cool%20charcoal%20and%20deep%20red%20cinematic%20color%20grade&width=1600&height=900&seq=jq-hero-17&orientation=landscape',
    ],
    actors: [
      { name: '长泽美咲', role: '饰 美咲' },
      { name: '山田悠真', role: '饰 悠真' },
    ],
  },
  {
    id: 'm18',
    title: '一场春梦',
    category: '电影',
    genres: ['文艺', '爱情'],
    region: '中国台湾',
    year: 2021,
    director: '林彦廷',
    cast: ['郭采宁', '陈柏宇'],
    synopsis: '旅途中的一场短暂相遇，让两个已婚的人在异乡动了不该动的心。',
    plot:
      '独自来到台南旅行的采宁，在民宿里遇见了同样独自出行的柏宇。两人都带着各自婚姻里的疲惫，在古城的巷弄与夜市之间度过了一段无关现实的日子。假期结束，他们约定互不打扰，可回到日常之后，那段春梦般的记忆却久久无法散去。',
    rating: 7.5,
    duration: '99分钟',
    cover:
      'https://readdy.ai/api/search-image?query=Taiwanese%20art%20film%20poster%20of%20two%20figures%20cycling%20past%20old%20alley%20walls%20in%20warm%20afternoon%20light%2C%20muted%20amber%20and%20deep%20red%20tones%20with%20soft%20grain%2C%20nostalgic%20romantic%20cinematic%20mood&width=400&height=600&seq=jq-mv-18&orientation=portrait',
    coverAlt: '一场春梦 电影海报',
    heroes: [
      'https://readdy.ai/api/search-image?query=Old%20Taiwanese%20alley%20with%20warm%20sunset%20light%2C%20potted%20plants%20and%20narrow%20lanes%2C%20muted%20amber%20and%20deep%20red%20cinematic%20color%20grade%2C%20nostalgic%20romantic%20mood&width=1600&height=900&seq=jq-hero-18&orientation=landscape',
    ],
    actors: [
      { name: '郭采宁', role: '饰 采宁' },
      { name: '陈柏宇', role: '饰 柏宇' },
    ],
  },
];